import { WithTooltip } from '@/shared/ui/with-tooltip/with-tooltip';
import clsx from 'clsx';
import styles from './action.module.css';
import { ActionButtonProps, ActionProps } from './action.props';

const ActionButton = ({ active, icon, className, ...events }: ActionButtonProps) => {
	const Icon = icon.component;

	return (
		<button
			className={clsx(styles.button, className, {
				[styles.active]: active,
			})}
			{...events}
		>
			<Icon
				className={clsx(
					{
						[styles.fillIcon]: icon.fillIcon,
						[styles.icon]: !icon.fillIcon,
					},
					icon.className,
				)}
			/>
		</button>
	);
};

export const Action = ({ tooltip, ...props }: ActionProps) => {
	return (
		<WithTooltip
			tooltip={tooltip}
			component={(tooltipProps) => <ActionButton {...tooltipProps} {...props} />}
		/>
	);
};
